import { useState, useEffect } from "react";
import styles from "./list.module.css";
import { ArrowBack } from "@mui/icons-material";
import axios from "axios";
import { TableLoader } from "../../components/ContentLoader";
import { authData, withAdminAuth } from "../../components/GetAuth";
import { Home } from "react-feather";
import { useNavigate, useParams } from "react-router-dom";

const EmailTemplatePreview = () => {
  const navigate = useNavigate();
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const { templateId } = useParams();
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);

  useEffect(() => {
    const fetchProducts = () => {
      setContentLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/email-templates/" + templateId, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchProducts();
  }, [API_TOKEN, templateId]);

  return (<>
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}><button onClick={(e) => navigate("/email-template/list")}><ArrowBack /></button> Preview: {allData?.title}</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Email Templates</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>Preview</li>
            </ol>
          </nav>
        </div>)}

        {!contentLoading && (<>

          <div className="CusTable">

            <div>
              <div dangerouslySetInnerHTML={{ __html: allData?.content }} />
            </div>

          </div>

        </>)}
      </div>
    </div>

  </>);
};

export default withAdminAuth(EmailTemplatePreview);